<template>
      <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                  <div class="nav-bar box-horizontal mb-0">
                <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                    <div class="flex-1">
                      <h3 class="m-0">Absensi</h3>
                      <p class="mb-0">History Absensi Orang2 ya gaess :)</p>
                    </div>
                  </div>
                  <div class="mt-3">
                    <button @click="data.tanggalBox = true;"  class="btn btn-info" v-show="!data.tanggalBox">Filter Tanggal</button>
                    <button @click="
                      data.karyawanBox = true"
                      class="btn btn-info" v-show="!data.karyawanBox">Filter Karyawan</button>
                  </div>
                  <div class="card mt-3">
                    <div class="card-body">
                        <div class="row">
                          <div class="col-md-3" v-show="data.tanggalBox">
                            <label for="tanggal" class="text-dark">Tanggal</label>
                            <div class="box-horizontal">
                              <vuejs-datepicker :format="theGet.customFormatter" id="tanggal" type="text" placeholder="Pilih Tanggal..." v-model="data.tanggal" style="width: 100%"></vuejs-datepicker>
                            </div>
                          </div>

                          <div class="col-md-3" v-show="data.tanggalBox">
                            <label for="tanggal" class="text-dark">Sampai Tanggal</label>
                            <div class="box-horizontal">
                              <vuejs-datepicker :format="theGet.customFormatter" id="tanggal" type="text" placeholder="Pilih Tanggal..." v-model="data.sampai" style="width: 100%"></vuejs-datepicker>
                            </div>
                          </div>

                          <div class="col-md-3" v-show="data.karyawanBox">
                            <label for="tanggal" class="text-dark">Teknisi</label>
                            <div class="box-horizontal">
                              <h3 class="text-info cursor-pointer m-0 mr-4" role="button" @click="data.modalTeknisi = true" v-text="data.karyawanNama === null ? 'Filter Karyawan ': data.karyawanNama">Pilih Teknisi</h3>
                            </div>
                          </div>
                          <div v-show="data.karyawanBox || data.tanggalBox">
                              <button class="btn btn-info btn-sm" type="button" style="height: 30px;" @click="theGet.datae()">Cari</button>
                          </div>
                        </div>

                        <div class="table-responsive">
                        <table class="table">
                            <thead class=" text-info">
                            <th width="50px">No</th>
                            <th>Nama Karyawan</th>
                            <th>Jabatan</th>
                            <th>Jam Masuk</th>
                            <th>Jam Pulang</th>
                            <th>Tanggal</th>
                            <th>Absen Dari</th>
                            </thead>
                            <!-- LOADING -->
                            <tbody v-show="data.loading">
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            </tbody>
                            <!-- DATA -->
                            <tbody v-show="!data.loading">
                            <tr v-for="(u, index) in theGet.data.List">
                                <td>
                                  {{index+1}}
                                </td>
                                <td>
                                  {{ u.nama }}
                                </td>
                                <td>
                                    <span class="d-block">{{ u.jabatan }}</span>
                                </td>
                                <td>
                                  {{myGlobal.jamIndo(u.masuk)}}</br>
                                  <span class="text-warning" v-show="parseInt(u.telat) > 0">Telat {{u.telat}} Menit</span>
                                </td>
                                <td>
                                  {{myGlobal.jamIndo(u.pulang)}}
                                </td>
                                <td>
                                  {{myGlobal.tglIndo(u.tanggal)}}
                                </td>
                                <td>
                                  {{u.absen_di}}
                                </td>
                            </tr>
                            <!-- NULL -->
                            <tr v-if="theGet.data.List == null">
                                <td></td>
                                <td>Tidak ada Data </td>
                            </tr>
                            <!-- NULL -->
                            <tr v-if="data.filterState == true">
                                <td></td>
                                <td><strong>Total Telat </strong></td>
                                <td></td>
                                <td>{{ data.totalTelat }} Menit</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        
                        <button type="button" class="btn btn-sm btn-info" @click="theGet.loadmore()">LOADMORE</button>
                        
                        <download-excel 
                          v-show="theGet.data.List != null"
                          style       = "padding: 0"
                          :data       = "data.json_datapelanggan"
                          :fields     = "data.json_fieldspelanggan"
                          worksheet   = "My Worksheet"
                          :before-generate = "theGet.startDownload"
                          :name       = "data.nameDoc"
                        >
                          <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                        </download-excel>

                      </div>
                    </div>
                  </div>
              </div>
                
            </div>
        </div>

        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalCekSingkron">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-body" style="max-height: 500px; overflow: auto">
                    <div v-show="data.loadingBox" class="text-center">
                      <h3 class="mb-0 text-info">Tunggu Sebentar...</h3>
                      <span>Sedang mencari data anda</span>
                    </div>
                    <div v-show="data.baru">
                      <h3 class="mb-0">Oops, tidak ada data</h3>
                      <span>Sepertinya Anda baru pertama kesini, buat akun untuk bisa menggunakan Akun ini </span>
                    </div>
                    <div v-show="!data.loadingBox" class="text-center">
                      <span>Akun Beatcom Network Anda :</span>
                      <h3 class="text-center text-info mt-1">Kentang</h3>
                      <button class="btn btn-info" @click="theGet.loginSubmit()">Gunakan akun ini</button>
                      <button class="btn btn-gray" @click="$router.go(-1)">Batalkan</button>
                    </div>
                  </div>
              </div>
          </div>
          
        </div>
        
        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalTeknisi">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document" >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Pilih Karyawan</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalTeknisi = false">
                    <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="height: 500px; overflow: auto">
                    <div class="table-responsive">
                      <table class="table">
                          <thead class=" text-info">
                          <th width="40px">No.</th>
                          <th>Nama</th>
                          <th>Jabatan</th>
                          <th>Aksi</th>
                          </thead>
                          <tbody>
                            <tr v-for="(u, index) in theGet.data.Teknisi">
                                <td>{{ index+1 }}</td>
                                <td>{{ u.knama }}</td>
                                <td>{{ u.jabatan }}</td>
                                <td>
                                    <button class="btn btn-sm btn-info" @click="data.modalTeknisi = false,theGet.pilihKaryawan(u.id,u.knama)"><i class="material-icons">check</i></button>
                                </td>
                            </tr>
                            <!-- NULL -->
                            <tr v-if="theGet.data.Teknisi == null">
                                <td></td>
                                <td>Tidak ada Data </td>
                            </tr>
                          </tbody>
                      </table>
                    </div>
                  </div>
              </div>
          </div>
          
        </div>

      </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/InterfaceAbsensi' 
import Loading from '@/globalFunc/Loading' 
import vuejsDatepicker from 'vuejs-datepicker'

export default {
  name: 'Beranda',
	components: { 
    vuejsDatepicker,
    "Loading" : Loading
	}, 
  setup() {
    const data = reactive({
      loading: true,
      tanggalBox: false,
      tanggal: null,
      sampai: null,
      modalTeknisi: false,
      karyawanBox: false,
      karyawanNama: null,
      karyawanID: null,
      filterState: false,
      totalTelat: 0,
      
      judulDoc: '',
      nameDoc: '',
      json_fieldspelanggan: {
        "No" : 'no',
        'Nama': 'nama',
        'Jabatan': 'jabatan',
        'Jam Masuk': 'masuk',
        'Jam Pulang': 'pulang',
        'Tanggal': 'tanggal',
        'Telat': 'telat',
        'Absen Dari': 'dari'
      },
      json_datapelanggan: [],
      json_metapelanggan: [
          [
              {
                  'key': 'charset',
                  'value': 'utf-8'
              }
          ]
      ],

      // ABSENSI MODAL
      modalCekSingkron: true,
      loadingBox: true,
      baru: false,
      page: 0
    })

    const theGet = {
      customFormatter(date) {
        return moment(date).format('YYYY-MM-DD');
      },
      data: reactive({
        List: [],
        Teknisi: [],
        Total: "0",
      }),
      startDownload() {
        //alert("start")
      },
      loadmore() {
        data.page = data.page + 1;
        theGet.dataeNow();
      },
      dataeNow() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi'),
          page: data.page
        };

        if(data.tanggal != null) {
          datax["tanggal"] = this.customFormatter(data.tanggal);
        }

        if(data.sampai != null) {
          datax["tanggal_sampai"] = this.customFormatter(data.sampai);

        }

        if(data.karyawanID != null) {
          datax["id"] = data.karyawanID
        }
        
        if(data.tanggal != null && data.sampai != null && data.karyawanID != null) {
          data.filterState = true;
        }

        //console.log(JSON.stringify(datax))
    
        var apiUrl = inter.historyAbsen();
        myGlobal.callAbsensi(datax,apiUrl).then(x => {
          
            //myGlobal.loger(x);

            data.loading = false;

            if (x.status == true) {
              if(data.page == 0) {
                theGet.data.List = x.data;
              } else {
                var datax = x.data;
                var values = [];
                var i;

                for (i = 0; i < datax.length; i++) {
                  theGet.data.List.push(datax[i]);
                }
              }

              theGet.data.Total = x.pesan.masuk;

              if(data.filterState == true) {

                let datae = theGet.data.List;
                
                let totalTelatT = 0;
                for(var i = 0; i < datae.length; i++) {
                  totalTelatT = totalTelatT + parseInt(datae[i]["telat"])
                }

                data.totalTelat = totalTelatT
                
              }
              
              var datax = theGet.data.List;
              
              var values = [];
              var i;

              for (i = 0; i < datax.length; i++) {
                
                var item1 = {
                    "no" : i+1,
                    'nama' : datax[i].nama, //this.tglIndo(data[i].due_date)
                    'jabatan' : datax[i].jabatan, //this.tglIndo(data[i].due_date)
                    'telat': datax[i].telat + " Menit",
                    'masuk': myGlobal.jamIndo(datax[i].masuk),
                    'pulang': myGlobal.jamIndo(datax[i].pulang),
                    'tanggal': myGlobal.tglIndo(datax[i].tanggal),
                    'dari': datax[i].absen_di
                };

                values.push(item1);                
              }

              data.json_datapelanggan = values;          
              data.judulDoc = ["Absensi - Per "+myGlobal.tglIndo(new Date)];
              data.nameDoc = "Absensi - Per "+myGlobal.tglIndo(new Date)+".xls";

            } else {
              if(data.page == 0) {
                theGet.data.List = null;
              } else {
                alert("Tidak ada Data lagi");
              }
            }
        })
      },
      datae() {
        data.loading = true;
        setTimeout(function() {
          theGet.dataeNow();
        }, 1000);
      },
      login() {
        data.loading = true;
        setTimeout(function() {
          theGet.loginNow();
        }, 1000);
      },
      loginNow() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        };
    
        var apiUrl = inter.login();
        myGlobal.callAbsensi(datax,apiUrl).then(x => {
          
            // myGlobal.loger(x);


            if (!x.status == true) {
              data.baru = true;
              
            } else {
              theGet.data.List = null;
            }
            
            data.loadingBox = false;

            // data.loading = false;

            /*

            */
        })
      },
      loginSubmit() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          nama: sessionStorage.getItem('admin')
        };
    
        var apiUrl = inter.loginSubmit();
        myGlobal.callAbsensi(datax,apiUrl).then(x => {
            //myGlobal.loger(x);

            if (x.status == true) {
              //data.baru = true;
              sessionStorage.setItem('myTokenAbsensi', x.data);

              data.modalCekSingkron = false;

              theGet.dataeNow();
              
            } else {
              //theGet.data.List = null;
              alert(x.pesan)
            }
            
        })
      },
      getKaryawan() {
          var datax = {
            token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi')
          };
      
          var apiUrl = inter.karyawanList();
          myGlobal.callAbsensi(datax,apiUrl).then(x => {
            //console.log(JSON.stringify(x))

            if (x.status == true) {

              this.data.Teknisi = x.data;
            
            } else {
            theGet.data.List = null;
            }
          })
      },
      pilihKaryawan(id,nama) {
        data.karyawanID = id,data.karyawanNama = nama;
      }
    }
    return {
      data,
      myGlobal,
      theGet
    }
  },
  mounted () {
    document.title = "Tugas";

    this.data.namaQ = sessionStorage.getItem('admin');

    let TokenAbsensi = sessionStorage.getItem("myTokenAbsensi");
    if(TokenAbsensi == null) {
      this.theGet.login();
    } else {
      this.data.modalCekSingkron = false;
      this.theGet.datae();
    }

    this.theGet.getKaryawan();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.cursor-pointer{
  cursor: pointer;
}
.modal {
	display: inherit;
}
.overlay {
	position:fixed;
	top:0;bottom:0;right:0;left:0;
	background-color: rgba(0,0,0,0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/absensi/history/main.vue